import { render, staticRenderFns } from "./VirtualCursor.vue?vue&type=template&id=bef7ded8&scoped=true"
import script from "./VirtualCursor.vue?vue&type=script&lang=js"
export * from "./VirtualCursor.vue?vue&type=script&lang=js"
import style0 from "./VirtualCursor.vue?vue&type=style&index=0&id=bef7ded8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef7ded8",
  null
  
)

export default component.exports